import Request from './request';
import crypto from 'crypto'
import { setJsonStorage } from '../util/storage'
import app from "../main";
import axios from 'axios';

export const querywxlogin = (querys) => {
  let params = querys.split("&");
  if (params.length > 0) {
    let par = {};
    for (let p in params) {
      let pp = params[p].split("=");
      par[pp[0]] = pp[1];
    }
    if (par['wxunionid']) {
      wxlogin(par['wxunionid']).then(res => {
        loged(res.data);
      });
    } else if (par['wxopenid'] && par['wxcode']) {
      wxphonelogin(par['wxopenid'], par['wxcode']).then(res => {
        loged(res.data);
      });
    }
  }
};

export const loged = (user) => {
  setJsonStorage('openai_user',user);
  getUserPrivileges().then(res => {
    if(res && res.status === 0){
      setJsonStorage('openai_privileges',res.data);
      //微信小程序分享跳转
      if(app.$browserType===1){
        app.$wx.miniProgram.redirectTo({url: '/pages/index/main?shareRedirect=1'})
      }
    }
  });
};

export const getDomain = () => {
  return Request.domain();
};

export const md5 = (str) => {
  return crypto.createHash('md5').update(str).digest('hex');
};

export const sha512 = (str) => {
  return crypto.createHash('sha512').update(str).digest('hex');
};

export const wxlogin = (wxunionid) => {
  return Request.post('/wxlogin', {unionid:wxunionid});
};

export const wxphonelogin = (wxopenid,wxcode) => {
  return Request.post('/wxphonelogin', {openid:wxopenid,code:wxcode});
};

export const wxPasswordChange = (npass,rpass) => {
  return Request.post('/user/password/wxmp/change', {npass:sha512(npass),rpass:sha512(rpass)});
};

export const websendphonevalid = (phone) => {
  return Request.post('/phone/regist/verification',{phone:phone});
};

export const webphoneregist = (params) => {
  let data = JSON.parse(JSON.stringify(params));
  data['password'] = sha512(data['password']);
  data['repassword'] = sha512(data['repassword']);
  return Request.post('/phone/regist/submit',data);
};

export const weblogin = (phone,password) => {
  return Request.post('/login/phone', { phone:phone,password:sha512(password) });
};

export const weblogout = () => {
  return Request.post('/logout', {});
};

export const refreshLogin = () => {
  return Request.get('/login/fresh',{});
};

export const getUserPrivileges = () => {
  return Request.get('/privileges', {});
};

export const getUserRecommendCount = () => {
  return Request.get('/user/recommend/count', {});
};

export const bindUserRecommend = (code) => {
  return Request.get('/user/recommend?code='+code, {});
};

export const searchAccessGoods = (uri) => {
  return Request.get('/user/access/search?uri='+uri,{});
};

export const searchShips = (keyword) => {
  return Request.get('/datacenter/standard/ship/search',{keyword:keyword});
};

export const payOrderCheck = () => {
  return Request.get('/pay/order/check/all',{});
};

export const payOrderGet = (order_id) => {
  return Request.get('/pay/order/get?order_id='+order_id,{});
};

export const createAccessOrder = (goods_id) => {
  return Request.get('/user/goods/access/order/create?access_goods_id='+goods_id,{});
};

export const wechatPrepay = (order_id,open_id) => {
  return Request.get('/pay/wechat/prepay',{order_id:order_id,open_id:open_id});
};

export const getUserGoodsRoleAll = () => {
  return Request.get('/user/goods/role/all',{});
};

export const createRoleOrder = (goods_id) => {
  return Request.get('/user/goods/role/order/create?role_goods_id='+goods_id,{});
};

export const openaiQuestion = (prompt,preset_id) => {
  return Request.get('/datacenter/standard/gemini/v1/conversation',{"prompt":prompt,"preset_id":preset_id});
};

export const userAccessValid = (uri,prompt) => {
  return Request.post('/user/access/valid?uri='+uri,{"prompt":prompt,"preset_id":"-1"});
};

export const getOrderSum = () => {
  return Request.get('/user/goods/access/order/sum',{});
};

export const getUserAccesOrderLog = (page,size) => {
  return Request.get('/user/goods/access/order/log',{uri:'/datacenter/standard/riskv4/ship/score',page:page,size:size});
};

export const getRoleOrderLog = (page,size) => {
  return Request.get('/user/goods/role/order/list',{page:page,size:size});
};

export const getAccessOrderLog = (page,size) => {
  return Request.get('/user/goods/access/order/list',{page:page,size:size});
};

export const userSignIn = () => {
  return Request.get('/user/sign/gift',{});
};

export const userSignConfig = () => {
  return Request.get('/user/sign/config',{});
};

export const uploadFile = (params) => {
  return Request.post('/file/upload',params,{headers:{'Content-Type':'multipart/form-data'}});
};

export const xunfeiAudioTranscriptionParse = (oss_path) => {
  return Request.get('/datacenter/standard/xunfei/audio/transcription/parse',{'oss_path':oss_path});
};

export const xunfeiAudioTranscriptionResult = (order_id) => {
  return Request.get('/datacenter/standard/xunfei/audio/transcription/result',{'order_id':order_id});
};

export const interviewRecordList = (params) => {
  return Request.get('/interview/record/list',params);
};

export const interviewRecordGet = (id) => {
  return Request.get('/interview/record/get',{'id':id});
};

export const interviewRecordUpdate = (params) => {
  return Request.post('/interview/record/update',params);
};

export const interviewRecordDel = (id) => {
  return Request.get('/interview/record/del',{'id':id});
};





// WEBPACK FOOTER //
// ./src/api/api.js